import { css } from '@emotion/react';
import { type FC } from 'react';
import { useTranslation } from '~/_shared/utils/hooks';
import type { MapListingRowItem } from '~/map/listing/tableData/mapRow/mapRow.component';

const toggleButtonStyle = css({
  background: 'none',
  border: 'none',
  padding: 0,
  color: 'inherit',
});

type MapRowToggleProps = Readonly<{
  item: MapListingRowItem;
  areSubMapsExpanded: boolean;
  className?: string;
  children?: React.ReactNode;

  onClick?: () => void;
}>;

export const MobileMapRowToggleComponent: FC<MapRowToggleProps> = (props) => {
  const [t] = useTranslation();

  if (!props.item.snapshots.length) {
    return <>{props.children}</>;
  }

  return (
    <button
      className={props.className}
      css={toggleButtonStyle}
      onClick={props.onClick}
      title={t(props.areSubMapsExpanded ? 'mapListing.subItems.collapse' : 'mapListing.subItems.expand')}
    >
      {props.children}
    </button>
  );
};
